import { useEffect } from 'react'
// key - the name of the key to respond to, compared against event.key
// action - the action to perform on key press
export default function useKeyPress (key: string, action: () => void) {
  useEffect(() => {
    function onKeyup (e: any) {
      if (e.key === key) action()
    }
    document.addEventListener('keyup', onKeyup)
    return () => document.removeEventListener('keyup', onKeyup)
  }, [action, key])
}
